//#region src/components/phone-number/phone-number.formatter.ts
function getSafePhoneNumber(input) {
	return input.length === 10 ? `+1${input}` : input.length === 11 ? `+${input}` : input;
}
function sanitizePhoneNumber(input) {
	return input.replace(/\D/g, "");
}
function isValidPhoneNumber(input, sanitize = false) {
	const re = /^\+1[0-9]\d{9}$/;
	if (sanitize) return re.test(getSafePhoneNumber(sanitizePhoneNumber(input)));
	return re.test(input);
}
/**
* @param input phone number, either in E.164 '+1nnnnnnnnnn', 10-digit 'nnnnnnnnnn', or unknown format
* @param sanitize whether to strip non-numeric characters from the input before validation and formatting
* @returns new phone number format in North American Numbering Plan '(nnn) nnn-nnnn'
*/
function formatPhoneNumber(input, sanitize = false) {
	const num = sanitize ? getSafePhoneNumber(sanitizePhoneNumber(input)) : getSafePhoneNumber(input);
	if (!isValidPhoneNumber(num)) {
		console.warn(`Invalid phone number format ${input}, must have +1 country code with 10-digit number`);
		return input;
	}
	return `(${num.slice(2, 5)}) ${num.slice(5, 8)}-${num.slice(8)}`;
}

//#endregion
export { formatPhoneNumber, getSafePhoneNumber, isValidPhoneNumber, sanitizePhoneNumber };